import apiFetch from "../components/util/fetch-utils";


export const FETCH_WORKSPACE_STATS_IN_PROGRESS = 'FETCH_WORKSPACE_STATS_IN_PROGRESS';
export const FETCH_WORKSPACE_STATS_SUCCESS = 'FETCH_WORKSPACE_STATS_SUCCESS';
export const FETCH_WORKSPACE_STATS_FAILURE = 'FETCH_WORKSPACE_STATS_FAILURE';


export function fetchWorkspaceStats(workspaceNumber) {


    return dispatch => {

        dispatch({type: FETCH_WORKSPACE_STATS_IN_PROGRESS});

        apiFetch('/api/stats?workspaceNumber=' + workspaceNumber)
            .then(response => {
                if (response.status === 200) {
                    response.json().then(responseJson => {
                        dispatch({type: FETCH_WORKSPACE_STATS_SUCCESS, payload: responseJson});
                    });
                } else {
                    dispatch({type: FETCH_WORKSPACE_STATS_FAILURE, error: response});
                }
            });
    }

}

